module.exports = __webpack_public_path__ + "img/new-handset-green.c6d73195.svg";